import { fetchme } from 'gso-fetchme';
async function deleteToken() {
    return fetchme('/api/auth-server/token/delete', {
        method: 'DELETE'
    });
}
export { deleteToken };
//# sourceMappingURL=auth-proxy.js.map